<template>
  <v-row>
    <v-col cols="12" class="ml-3 headline font-weight-bold">
      <slot name="before"/>
      <span>{{ title }}</span>
      <slot name="after"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
